import { useEffect } from 'react';
import { useNotificationSound } from '../hooks/useNotificationSound';

/**
 * Component that initializes notification sound handling
 * Must be rendered within the app to listen for service worker messages
 */
export function NotificationSoundProvider({ children }) {
  const { initAudio } = useNotificationSound();

  // Initialize audio context on first user interaction
  useEffect(() => {
    const handleInteraction = () => {
      initAudio();
      // Remove listeners after first interaction
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
    };

    document.addEventListener('click', handleInteraction);
    document.addEventListener('touchstart', handleInteraction);

    return () => {
      document.removeEventListener('click', handleInteraction);
      document.removeEventListener('touchstart', handleInteraction);
    };
  }, [initAudio]);

  return children;
}

export default NotificationSoundProvider;
